import script from "./TermsAndConditionsCheckbox.vue?vue&type=script&lang=ts&setup=true"
export * from "./TermsAndConditionsCheckbox.vue?vue&type=script&lang=ts&setup=true"

import "./TermsAndConditionsCheckbox.vue?vue&type=style&index=0&id=ac9de38c&scoped=true&lang=css"

import exportComponent from "/Users/jnshul/Documents/tagluffa_i_vue3/main_page/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ac9de38c"]])

export default __exports__